import Wrapper from "../../layout/Wrapper";
import CreateCommissionPayoutPage from "../../screens/comission/CreateCommissionPayoutPage";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
	title: "CreateCommissionPayoutPage",
	description: "",
};
	
export default function CreateCommissionPayoutPageRoute() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CreateCommissionPayoutPage />
		</Wrapper>
	);
}